import React from 'react';
import { BEAT, parkeoResults } from '../../data/reel';
import { SceneProps } from '../../types/reel';
import { punch, reveal } from '../../utils/reelMath';
import { ParkeoPhone, ParkeoScreen } from './ParkeoPhone';
import { SceneLayer } from './SceneLayer';
const phones: {
  screen: ParkeoScreen;
  y: number;
}[] = [{
  screen: 'map',
  y: 30
}, {
  screen: 'code',
  y: -20
}, {
  screen: 'spot',
  y: 30
}];

/** Clean case frame: three Parkeo screens land one per beat, results on the fourth. */
export function ParkeoScene({
  time,
  scene
}: SceneProps) {
  const resultsAt = scene.start + 3 * BEAT;
  return <SceneLayer time={time} start={scene.start} end={scene.end} fade={0.12} data-id="element-155" data-mp="110fknt4taatc">
      {({
      p
    }) => <div className="absolute inset-0 bg-cream" style={{
      transform: `scale(${punch(time, scene.start, 0.05, 0.35) + 0.02 * p})`
    }} data-id="element-156" data-mp="15zs9ukj5ntz3">
          <div className="absolute left-[150px] top-[250px] w-[560px]" data-id="element-157" data-mp="2vegj4cwg8vsw">
            <p className="font-mono text-[20px] text-muted" data-id="element-158" data-mp="30bgsoxsicgor">Parkeo · Parking app</p>
            <h2 className="mt-5 text-[84px] font-medium leading-[1.02] tracking-[-0.045em] text-ink" data-id="element-159" data-mp="1hs64ljlqmyxi">
              Registration in 25 seconds.
            </h2>
            <ul className="mt-12 space-y-5" data-id="element-160" data-mp="1dpji7y7u667p">
              {parkeoResults.map((r, i) => {
            const o = reveal(time, resultsAt + i * 0.12, 0.3);
            return <li key={r.label} className="flex items-baseline gap-5 border-t border-line pt-4" style={{
              opacity: o,
              transform: `translateY(${(1 - o) * 12}px)`
            }} data-id="element-161" data-mp="1mlr4jh6w62zc" data-mpi={i}>
                    <span className="w-[130px] text-[44px] font-medium tracking-[-0.04em] text-sage" data-id="element-162" data-mp="18sjdprqmxbip">{r.value}</span>
                    <span className="text-[22px] text-ink" data-id="element-163" data-mp="13sewu0lteery">{r.label}</span>
                    <span className="ml-auto font-mono text-[16px] text-muted" data-id="element-164" data-mp="2k6wvceusouqa">was {r.from}</span>
                  </li>;
          })}
            </ul>
          </div>

          <div className="absolute left-[800px] top-1/2 flex -translate-y-1/2 gap-8" style={{
        transform: `translate(${-30 * p}px, -50%)`
      }} data-id="element-165" data-mp="2n9b5odotjc3y">
            {phones.map((ph, i) => {
          const r = reveal(time, scene.start + i * BEAT, 0.35);
          return <div key={ph.screen} style={{
            opacity: r,
            transform: `translateY(${ph.y + (1 - r) * 50}px) scale(${0.96 + 0.04 * r})`
          }} data-id="element-166" data-mp="2w7wma3aqch23" data-mpi={i}>
                  <ParkeoPhone screen={ph.screen} data-id="element-167" data-mp="28l6ndatoh2lp" />
                </div>;
        })}
          </div>
        </div>}
    </SceneLayer>;
}